import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const campaignTemplatesSlice = createAppSlice({
  name: 'campaignTemplates',
  initialState,
  reducers,
});

export default campaignTemplatesSlice.reducer;

export const { loadCampaignTemplates } = campaignTemplatesSlice.actions;
